'use client';

import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { DownArrowIcon, UpArrowIcon } from '@assets/icons';

import { AccordionWrapper, ReverseAccordionHeader } from './styled';

const ReverseAccordion = ({
  children,
  isOpen,
  setIsOpen,
  title,
}: {
  children?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (boolean) => void;
  title: string;
}) => {
  return (
    <AccordionWrapper>
      {children}
      <ReverseAccordionHeader onClick={() => setIsOpen(!isOpen)}>
        <Typography variant='caption2' color='R600'>
          {title}
        </Typography>
        <CustomIcon
          icon={isOpen ? UpArrowIcon : DownArrowIcon}
          fontSize={16}
          paletteColor='R600'
        />
      </ReverseAccordionHeader>
    </AccordionWrapper>
  );
};

export default ReverseAccordion;
